import { useState, useRef, useEffect } from "react";
import { Stack, Button, Form } from "react-bootstrap";
import Motivo from "./Motivo";
import Fecha from "./Fecha";

const styles = {
  comentario: {
    backgroundColor: "var(--color-background)",
    maxWidth: "100%",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordWrap: "break-word",
  },
  atencion: {
    backgroundColor: "var(--color-background-3)",
    maxWidth: "100%",
  },
  iconButton: {
    background: "none",
    border: "none",
    color: "var(--color-text-muted)",
    cursor: "pointer",
    padding: 0,
    marginLeft: "0.5rem",
  },
};

function TarjetaAtencion({ atencion, handleEditComentario, handleSolicitarAnulacion}) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedComentario, setEditedComentario] = useState(
    atencion.descripcion || ""
  );

  const textareaRef = useRef(null);

  // Cuando entra en modo edición de comentario, enfoca y mueve el cursor al final
  useEffect(() => {
    if (isEditing && textareaRef.current) {
      const el = textareaRef.current;
      el.focus();
      el.selectionStart = el.selectionEnd = el.value.length;
    }
  }, [isEditing]);

  const handleSave = () => {
    handleEditComentario(editedComentario, atencion.idAt);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedComentario(atencion.descripcion || "");
  };

  return (
    <div className="p-3 rounded border" style={styles.atencion}>
      <Stack gap={2}>
        <Stack direction="horizontal">
          <div className="me-auto mb-1">
            <Motivo motivo={atencion.motivo} />
          </div>
          {!isEditing && (
      <>
        {atencion?.editable && (
        <button
          onClick={() => setIsEditing(true)}
          style={styles.iconButton}
          title="Editar comentario"
          type="button"
          >
          <i className="bi bi-pencil-square fs-5"></i>
        </button>
      )}
        
        {atencion?.anulable && (
        <button
          onClick={() => handleSolicitarAnulacion(atencion)}
          style={styles.iconButton}
          title="Anular atención"
          type="button"
          >
          <i className="bi bi-trash3 fs-5 text-danger"></i>
        </button>
      )}
      </>
    )}
        </Stack>

        {isEditing ? (
          <div>
            <Form.Control
              as="textarea"
              rows={3}
              ref={textareaRef}
              value={editedComentario}
              onChange={(e) => setEditedComentario(e.target.value)}
            />
            <Stack direction="horizontal" gap={2} className="mt-2">
              <Button
                variant="secondary"
                className="ms-auto"
                size="sm"
                onClick={handleCancel}
              >
                Cancelar
              </Button>
              <Button className="btn-accent" size="sm" onClick={handleSave}>
                Guardar cambios
              </Button>
            </Stack>
          </div>
        ) : (
          <div className="d-flex align-items-start">
            
              {atencion.descripcion && atencion.descripcion.trim() !== "" ? (
                <div
              className="rounded border p-2 flex-grow-1"
              style={styles.comentario}
            >
              {editedComentario}
            </div>
              ) : (
                <p className="m-0 text-muted"> Sin comentarios</p>
              )}
          </div>
        )}

        <Stack direction="horizontal">
          <p className="my-auto">Tomada por: {atencion.funcionario.nombre}</p>
          <div className="ms-auto">
            <Fecha fecha={atencion.fecha} />
          </div>
        </Stack>
      </Stack>
    </div>
  );
}

export default TarjetaAtencion;
